import * as tslib_1 from "tslib";
import { NavigationEnd, Router, } from '@angular/router';
import { AppStateFacade, } from '@app-state';
import { FOLDER_ID_PARAM, TENANCY_ID_PARAM, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { restrictedUrlTree } from '@pages/shared/restricted-access';
import { AuthService } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import { filter, map, take, } from 'rxjs/operators';
var FolderParamGuard = /** @class */ (function () {
    function FolderParamGuard(_appState, _router, _snack, _translateService, _authService) {
        this._appState = _appState;
        this._router = _router;
        this._snack = _snack;
        this._translateService = _translateService;
        this._authService = _authService;
    }
    FolderParamGuard.prototype.canActivate = function (_, state) {
        var _this = this;
        if (this._appState.user.authState !== 1 /* LoggedInAsTenant */) {
            return true;
        }
        var paramMap = state.root.queryParamMap;
        var urlFolder = parseNumberOrNull(paramMap.get(FOLDER_ID_PARAM));
        var urlTenancy = parseNumberOrNull(paramMap.get(TENANCY_ID_PARAM));
        var currentUserFolder = this._appState.user.folder.value.id;
        var currentUserTenancy = this._appState.user.value.tenancyId;
        if (urlTenancy !== null && currentUserTenancy !== urlTenancy) {
            return this._redirect();
        }
        if (urlFolder !== null && currentUserFolder !== urlFolder) {
            return this._appState.user.folder.set(urlFolder)
                .pipe(map(function (success) { return success || _this._redirect(); }));
        }
        // FIXME: ???
        this._router.events.pipe(filter(function (ev) { return ev instanceof NavigationEnd; }), filter(function () { return _this._appState.user.authState === 1 /* LoggedInAsTenant */; }), filter(function () { return !_this._authService.pendingLogout$.value; }), take(1)).subscribe(function () {
            var _a;
            if (urlFolder == null &&
                urlTenancy == null &&
                _this._appState.user.folder.hasAny) {
                _this._router.navigate([state.url.split('?')[0]], {
                    queryParams: tslib_1.__assign({}, state.root.queryParams, (_a = {}, _a[FOLDER_ID_PARAM] = currentUserFolder, _a[TENANCY_ID_PARAM] = currentUserTenancy, _a)),
                    preserveFragment: true,
                    replaceUrl: true,
                });
            }
        });
        return true;
    };
    FolderParamGuard.prototype._redirect = function () {
        this._snack.error(this._translateService.instant('snack_ou_access_denied'));
        return restrictedUrlTree(this._router);
    };
    return FolderParamGuard;
}());
export { FolderParamGuard };
function parseNumberOrNull(param) {
    if (param === null) {
        return null;
    }
    return Number(param);
}
